// Generated by genversion.
module.exports = '2.12.6';
